"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.JurisdictionAbbreviation = void 0;
exports.instanceOfJurisdictionAbbreviation = instanceOfJurisdictionAbbreviation;
exports.JurisdictionAbbreviationFromJSON = JurisdictionAbbreviationFromJSON;
exports.JurisdictionAbbreviationFromJSONTyped = JurisdictionAbbreviationFromJSONTyped;
exports.JurisdictionAbbreviationToJSON = JurisdictionAbbreviationToJSON;
exports.JurisdictionAbbreviationToJSONTyped = JurisdictionAbbreviationToJSONTyped;
/**
 *
 * @export
 */
exports.JurisdictionAbbreviation = {
    Ak: 'AK',
    Al: 'AL',
    Ar: 'AR',
    As: 'AS',
    Az: 'AZ',
    Carn: 'CARN',
    Cavn: 'CAVN',
    Co: 'CO',
    Ct: 'CT',
    Dc: 'DC',
    De: 'DE',
    Fl: 'FL',
    Ga: 'GA',
    Gu: 'GU',
    Hi: 'HI',
    Ia: 'IA',
    Id: 'ID',
    Il: 'IL',
    In: 'IN',
    Ks: 'KS',
    Ky: 'KY',
    Larn: 'LARN',
    Lapn: 'LAPN',
    Ma: 'MA',
    Md: 'MD',
    Me: 'ME',
    Mi: 'MI',
    Mn: 'MN',
    Mo: 'MO',
    Mp: 'MP',
    Ms: 'MS',
    Mt: 'MT',
    Nc: 'NC',
    Nd: 'ND',
    Ne: 'NE',
    Nh: 'NH',
    Nj: 'NJ',
    Nm: 'NM',
    Nv: 'NV',
    Ny: 'NY',
    Oh: 'OH',
    Ok: 'OK',
    Or: 'OR',
    Pa: 'PA',
    Ri: 'RI',
    Sc: 'SC',
    Sd: 'SD',
    Tn: 'TN',
    Tx: 'TX',
    Ut: 'UT',
    Va: 'VA',
    Vi: 'VI',
    Vt: 'VT',
    Wa: 'WA',
    Wi: 'WI',
    Wvrn: 'WVRN',
    Wvpn: 'WVPN',
    Wy: 'WY'
};
function instanceOfJurisdictionAbbreviation(value) {
    for (const key in exports.JurisdictionAbbreviation) {
        if (Object.prototype.hasOwnProperty.call(exports.JurisdictionAbbreviation, key)) {
            if (exports.JurisdictionAbbreviation[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function JurisdictionAbbreviationFromJSON(json) {
    return JurisdictionAbbreviationFromJSONTyped(json, false);
}
function JurisdictionAbbreviationFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function JurisdictionAbbreviationToJSON(value) {
    return value;
}
function JurisdictionAbbreviationToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=JurisdictionAbbreviation.js.map